<template>
  <v-snackbar v-model="show" :timeout="timeout" :color="color">
    {{ text }}
    <template v-slot:action="{ attrs }">
      <v-btn icon @click="show = false" v-bind="attrs">
        <v-icon>{{mdiClose}}</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import {mdiClose} from "@mdi/js";
export default {
  props: {
    value: Boolean,
    text: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "red",
    },
    timeout: {
      type: Number,
      default: 10000,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.reset();
        this.$emit("input", value);
      },
    },
  },
  data: () => ({
    //svg icons
    mdiClose,
  }),
  methods: {
    reset() {
      console.log("reset");
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
